<template>

    <div class="home">

        <web-ar></web-ar>

    </div>

</template>

<script>

    import WebAr from '@/components/WebAr.vue'

    export default {

        name: 'Home',

        components: {
            WebAr
        }

    }

</script>

<style lang="scss" scoped>

    .home {

    }

</style>
